import { getBlob, getBlobOrError } from './axiosHelper';
import challengerEnv from '../lib/challengerEnv.js';
import { openDocument } from '../lib/downloadDocument.js';

const correspondencePath = 'external/correspondence-enquiries/v1/api'

const downloadDocument = async (docId, filename) => {
  if (docId == null || typeof docId == 'undefined') {
    throw 'Download Documents - ID parameter does not exists';
  }
  let docName = docId;
  if (filename !== null && typeof filename !== 'undefined') {
    docName = filename;
  }

  let url='';
  if (challengerEnv().mockApiResponses) {
    if(typeof(window)!='undefined'){
      const host = window.location.origin;
      url = host.concat('/MockDocumentCorrespondence.pdf');
    }
    }
  else{
    url = `${challengerEnv().apiBaseUrl}/${correspondencePath}/documents/${docId}`;
    }

  const document = await getBlob(url); // This needs to be enable for the API interaction

  if (document == null) {
    throw 'Download Documents API returned null';
  }

  // 500 status
  // Trying to cacth the API errors here
  if (typeof document.errors != 'undefined') {
    if (document.errors.length > 0) {
      throw 'Download Documents API returned errors';
    }
  }

  // 200
  try {
    openDocument(document, docName + '.pdf', 'application/pdf');
  } catch (ex) {
    throw 'Error downloading the document on UI ' + ex;
  }
};

// Build the URL to download the document - passing doc id and name as parameter
// Format will be: /documents/ID?doc_name=NAME
// We need to track the URL for a specific document - Using DocId will make the URL unique per document - However Document Name in URL path could be problematic if someone rename the document
const getDocUrl = (id, name, type) => {
  // If there is no name passed - default will be to use the ID
  let cleanName = id;
  if (name !== null) {
    // Need to make sure the Name parameter is URL ready - cleanup chars not allowed in
    cleanName = encodeURI(name.replace(' ', '_'));
  }
  return '/documents/' + id + '?doc_name=' + cleanName + '&doc_type=' + encodeURI(type);
};

const downloadAnnualStatement = async (docId, filename) => {
  if (docId == null || typeof docId == 'undefined') {
    throw 'Download Annual statement - ID parameter is not defined';
  }
  let docName = 'Annual statement';
  if (filename !== null && typeof filename !== 'undefined') {
    docName = filename;
  }

  let url='';
  if (challengerEnv().mockApiResponses) {
    const host = window.location.origin;
    url = host.concat('/MockDocumentCorrespondence.pdf');
    }
  else{
    url = `${challengerEnv().apiBaseUrl}/${correspondencePath}/documents?accountNo=${docId}`;
    }

  const document = await getBlobOrError(url); // This needs to be enable for the API interaction

  if (document == null) {
    throw 'Download annual statement API returned null';
  }

  // Catching business errors - document unavailable
  if (typeof document.errors != 'undefined') {
    if (document.errors.length > 0) {
      // we have some business errors - those are different from the Technical error: document unavailable
      return false;
    }
  }

  // 200
  try {
    openDocument(document, docName + '.pdf', 'application/pdf');
  } catch (ex) {
    throw 'Error downloading the annual statement on UI ' + ex;
  }
  return true;
};

// Build the URL to download the annual statement - passing doc id and name as parameter
// Format will be: /annualstatement/ID?doc_name=NAME
// We need to track the URL for a specific document - Using DocId will make the URL unique per document - However Document Name in URL path could be problematic if someone rename the document
const getStatementUrl = (id, name) => {
  // If there is no name passed - default will be AnnualStatement_ID
  let cleanName = 'AnnualStatement_' + id;
  if (name !== null) {
    // Need to make sure the Name parameter is URL ready - cleanup chars not allowed in
    cleanName = encodeURI(name.replace(' ', '_'));
  }
  return '/statements/' + id + '?doc_name=' + cleanName + '&doc_type=AnnualStatement';
};

export { downloadDocument, getDocUrl, downloadAnnualStatement, getStatementUrl };
